import React, { useState } from "react";
import { useAuth } from "../context/AuthContext";
import { useNavigate } from "react-router-dom";
import { Diamond, KeyRound } from "lucide-react";
import { toast } from "sonner";
import api from "../lib/api";

export default function ChangePassword() {
  const { user, refreshUser, logout } = useAuth();
  const navigate = useNavigate();
  const forced = !!user?.must_change_password;
  const [current, setCurrent] = useState("");
  const [pw1, setPw1] = useState("");
  const [pw2, setPw2] = useState("");
  const [saving, setSaving] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    if (pw1.length < 6) return toast.error("Yeni şifre en az 6 karakter olmalı");
    if (pw1 !== pw2) return toast.error("Şifreler eşleşmiyor");
    setSaving(true);
    try {
      const body = { new_password: pw1 };
      if (!forced) body.current_password = current;
      await api.post("/auth/change-password", body);
      toast.success("Şifreniz güncellendi. Lütfen tekrar giriş yapın.");
      await logout();
      navigate("/login", { replace: true });
    } catch (err) {
      toast.error(err?.response?.data?.detail || "İşlem başarısız");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="min-h-screen w-full flex items-center justify-center bg-[#faf7f2] p-4" data-testid="change-password-root">
      <form onSubmit={onSubmit} className="w-full max-w-md card-lux p-8">
        <div className="flex items-center gap-2 mb-4">
          <Diamond className="w-5 h-5" style={{ color: "#c5a059" }} />
          <span className="font-mono-code text-xs tracking-[0.35em] text-stone-500">
            RIVACO
          </span>
        </div>
        <h1 className="font-serif-display text-3xl text-stone-900 mb-1">
          {forced ? "İlk Girişiniz" : "Şifre Değiştir"}
        </h1>
        <p className="text-sm text-stone-500 mb-6">
          {forced
            ? "Devam etmek için yeni bir şifre belirleyin."
            : "Yeni şifrenizi güvenli tutun. Tüm oturumlarınız kapanacak."}
        </p>

        {!forced && (
          <>
            <Field label="Mevcut Şifre">
              <input
                data-testid="cp-current"
                type="password"
                required
                value={current}
                onChange={(e) => setCurrent(e.target.value)}
                className="w-full px-4 py-3 rounded-lg border border-stone-200 focus:border-amber-500 outline-none"
              />
            </Field>
          </>
        )}
        <Field label="Yeni Şifre">
          <input
            data-testid="cp-new1"
            type="password"
            required
            value={pw1}
            onChange={(e) => setPw1(e.target.value)}
            className="w-full px-4 py-3 rounded-lg border border-stone-200 focus:border-amber-500 outline-none"
          />
        </Field>
        <Field label="Yeni Şifre (Tekrar)">
          <input
            data-testid="cp-new2"
            type="password"
            required
            value={pw2}
            onChange={(e) => setPw2(e.target.value)}
            className="w-full px-4 py-3 rounded-lg border border-stone-200 focus:border-amber-500 outline-none"
          />
        </Field>

        <button
          data-testid="cp-submit"
          type="submit"
          disabled={saving}
          className="w-full mt-4 py-3 rounded-lg gold-gradient text-white font-medium disabled:opacity-60"
        >
          <span className="inline-flex items-center gap-2">
            <KeyRound className="w-4 h-4" />
            {saving ? "Kaydediliyor..." : "Şifreyi Kaydet"}
          </span>
        </button>
      </form>
    </div>
  );
}

function Field({ label, children }) {
  return (
    <label className="block mb-4">
      <div className="text-xs uppercase tracking-wider font-semibold text-stone-500 mb-1">
        {label}
      </div>
      {children}
    </label>
  );
}
